@if (loading()) {
<span class="text-sm text-[#666666]">CSR Responsible for Error</span>
<div class="animate-pulse h-[42px] w-full bg-[#333333] rounded-md max-w-input"></div>
} @else {
<div [formGroup]="formGroup">
    <sag-ui-autocomplete
        [required]="true"
        [formControlName]="controlName"
        label="CSR Responsible for Error"
        placeholder="Select CSR"
        class="max-w-input"
    >
        @for (user of users; track $index) {
        <sag-ui-autocomplete-option [value]="user.gid"
            >{{ user.firstName }} {{ user.lastName }}</sag-ui-autocomplete-option
        >
        }
    </sag-ui-autocomplete>
</div>
}
